import { render, staticRenderFns } from "./AppMainTable.vue?vue&type=template&id=b0e2c6ee&"
import script from "./AppMainTable.vue?vue&type=script&lang=js&"
export * from "./AppMainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports